import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Autocomplete,
} from "@mui/material";
import Swal from "sweetalert2";
import { customerservice, companyManagementUrl } from "../../../../config";
import {
  executeAnyMutation,
  fetchJsonDynamic,
} from "../../../../data/DynamicServiceNew/jsondynamicservice";
import Joyride from "react-joyride";


const BranchMigrate = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const [searchTerm, setSearchTerm] = useState("");
  const [branchData, setBranchData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [FilteredRegionData, setFilteredRegionData] = useState([]);
  const [selectedSearchBranch, setSelectedSearchBranch] = useState(null);
  const [branchSelected, setBranchSelected] = useState("");
  const [regionSelected, setRegionSelected] = useState("");
  const [dashboardData, setDashboardData] = useState(null);
const [runTour, setRunTour] = useState(() => {
  return localStorage.getItem("branchMigrationTourCompleted") !== "true";
});

const steps = [
  {
      target: ".tour-branch-search",
      content: "Search and select a branch you want to migrate from.",
    },
    {
      target: ".tour-dashboard-card",
      content: "This card shows dashboard metrics for the selected branch.",
    },
    {
      target: ".tour-region-select",
      content: "Select the destination region for this branch migration.",
    },
    {
      target: ".tour-submit-button",
      content: "Click here to submit the migration request.",
    },
  ];
  // Fetch branch data
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await fetchJsonDynamic(
          "branch",
          null,
          null,
          companyManagementUrl.uri
        );
        const regionresponse = await fetchJsonDynamic(
          "region",
          null,
          null,
          companyManagementUrl.uri
        );
        const allBranches = JSON.parse(response.results) || [];
        const allRegions = JSON.parse(regionresponse.results) || [];
        setRegionData(allRegions);
        setBranchData(allBranches);
      } catch (error) {
        console.error("Error fetching branch data:", error);
      }
    };
    fetchBranches();
  }, []);

  // Fetch dashboard data
  const fetchDashboardData = async (branchId) => {
    try {
      const response = await fetchJsonDynamic(
        "dashboardMetricsById",
        "dashboardMetrics",
        { branchid: branchId },
        companyManagementUrl.uri
      );
      if (response?.results) {
        const data = JSON.parse(response.results)[0];
        setDashboardData(data || null);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  // When a branch is selected in the search dropdown, fetch its dashboard data
  useEffect(() => {
    if (selectedSearchBranch) {
      fetchDashboardData(selectedSearchBranch.Id);
    }
  }, [selectedSearchBranch]);

  const changeRegionbased = async (selectedBranch) => {
    // Find the selected branch from branchData
    const branch = branchData.find((branch) => branch.Id === selectedBranch.Id);
    if (!branch) return;

    // Extract regionId from the found branch
    const regionId = branch.RegionId;
    // Filter regionData based on the extracted regionId
    const filteredRegions = regionData.filter(
      (region) => region.Id !== regionId
    );
    setFilteredRegionData(filteredRegions);
  };
  // Submit customer migration
  const handleCustomersMigrationSubmit = async () => {
    if (!selectedSearchBranch || !regionSelected) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please select both source and destination Region.",
      });
      return;
    }

    try {
      const mutationData = {
        branchId: selectedSearchBranch.Id,
        regionidto: regionSelected,
      };

      const response = await executeAnyMutation(
        "branchRegionMigration",
        mutationData,
        "inputModel",
        false,
        customerservice.uri
      );

      if (response.results === "200") {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Branch migrated successfully.",
        }).then(() => {
          // Clear all fields
          setSearchTerm("");
          setSelectedSearchBranch(null);
          setBranchSelected("");
          setDashboardData(null);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: response.error || "An unexpected error occurred.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Joyride
  steps={steps}
  run={runTour}
  continuous
  scrollToFirstStep
  showProgress
  showSkipButton
  styles={{
    options: {
      zIndex: 10000,
      primaryColor: "#1976d2", // Matches MUI primary
    },
  }}
  callback={(data) => {
    const { status } = data;
    const finishedStatuses = ["finished", "skipped"];
    if (finishedStatuses.includes(status)) {
      localStorage.setItem("branchMigrationTourCompleted", "true");
      setRunTour(false);
    }
  }}
/>
<Button variant="outlined" onClick={() => setRunTour(true)} sx={{ mb: 2 }}>
  Start Tour
</Button>


      <Typography variant="h5">Branch Dashboard</Typography>

      {/* Search Dropdown */}
      <Autocomplete
        className="tour-branch-search"
        options={branchData}
        getOptionLabel={(option) => option.Name || ""}
        value={selectedSearchBranch}
        onChange={(e, newValue) => {
          setSelectedSearchBranch(newValue);
          changeRegionbased(newValue);
        }}
        inputValue={searchTerm}
        onInputChange={(e, newInputValue) => setSearchTerm(newInputValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search Branch by Name"
            placeholder="Start typing to search..."
            variant="outlined"
            fullWidth
            margin="normal"
          />
        )}
      />

      {selectedSearchBranch && (
        <>
          {/* Dashboard Data */}
          <Card variant="outlined" sx={{ mb: 2 }} className="tour-dashboard-card">
            <CardContent>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Branch Summary
              </Typography>
              {dashboardData ? (
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={12} sm={6}>
                    <Typography>
                      <strong>Total Customers:</strong>{" "}
                      {dashboardData.Total_Customers}
                    </Typography>
                    <Typography>
                      <strong>Outstanding Loan Balance (OLB):</strong>{" "}
                      {dashboardData.Outstanding_Loan_Balance.toFixed(2)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography>
                      <strong>New Customers:</strong>{" "}
                      {dashboardData.New_Customers}
                    </Typography>
                    <Typography>
                      <strong>Loans Due Today:</strong>{" "}
                      {dashboardData.Loans_Due_Today}
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                <Typography>No dashboard data available.</Typography>
              )}
            </CardContent>
          </Card>

          {/* Destination Branch Selection */}
          <Card variant="outlined" sx={{ mb: 2 }} className="tour-region-select">
            <CardContent>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Select Destination Region
              </Typography>
              <FormControl fullWidth>
                <InputLabel>Select Region</InputLabel>
                <Select
                  value={regionSelected}
                  onChange={(e) => setRegionSelected(e.target.value)}
                >
                  <MenuItem value="" disabled>
                    Select Region
                  </MenuItem>
                  {FilteredRegionData.map((region) => (
                    <MenuItem key={region.Id} value={region.Id}>
                      {region.Name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </CardContent>
          </Card>

          {/* Submit Button */}
          <Button
            className="tour-submit-button"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleCustomersMigrationSubmit}
          >
            Submit For Branch Migration
          </Button>
        </>
      )}
    </Box>
  );
};

export default BranchMigrate;